import { render, staticRenderFns } from "./CustomersPage.vue?vue&type=template&id=f41b099a&scoped=true&"
import script from "./CustomersPage.vue?vue&type=script&lang=js&"
export * from "./CustomersPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomersPage.vue?vue&type=style&index=0&id=f41b099a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41b099a",
  null
  
)

export default component.exports